export default "__VITE_ASSET__18b8fb46__"